import {TestData, TestState, TestResults} from 'Models'
import {resultsViewModeTypes as vmTypes} from 'Shared'
import viewTypes from '@features/ViewState/types/viewTypes'


export default {
    computed: {
        routeName() { return this.$route && this.$route.name ? this.$route.name : '' },
        isRealTest()            { return TestData.isRealTest() },
        isExercise()           { return !TestData.isRealTest() &&  !this.isStatistics && !this.isRevision && !this.isRevisionResults },
        isTestMode()            { return this.isRoute('startTest') },
        isExerciseMode()        { return this.isRoute('exercise') },
        isDashboard()           { return this.isRoute('dashboard') },
        isMainCategoriesView()  { return this.isRoute('mainCategories') },
        isBookmarks()           { return this.isRoute('bookmarks') },
        isBookmarkRevision()    { return this.isRoute('bookmarktest') },
        isStatistics()          { return this.isRoute('statistics') },
        isRealTestStats()       { return this.isRoute('testStats') },
        isMyArea()              { return this.isRoute('myarea') },
        isLicences()            { return this.isRoute('licences') },
        isBills()               { return this.isRoute('bills') },
        isRevision()            { return this.isRoute('revision') || window.location.href.includes('plus/verwaltung/stats')  },
        isRevisionResults()     { return this.isRoute('revisionResults') || window.location.href.includes('plus/verwaltung/stats') },

        hasRouteName()          { return this.$route && this.$route.name },
        hasTestStarted()        { return TestData.hasStarted(); },
        hasTestEnded()          { return TestData.hasEnded(); },
        isTestActive()          { return TestData.isTestRunning(); },

        isResultsView()                 { return TestState.isInResultsMode(); },
        isPrintResultsView()           { return this.isResultsDetailsView && TestResults.isCurrentViewModeOfType(vmTypes.print); },
        isMainCategoriesResultsView()   { return this.isResultsDetailsView && TestResults.isCurrentViewModeOfType(vmTypes.maincategories); },
        isSubCategoriesResultsView()    { return this.isResultsDetailsView && TestResults.isCurrentViewModeOfType(vmTypes.subcategories); },
        isSummaryResultsView()          { return this.isResultsDetailsView && TestResults.isCurrentViewModeOfType(vmTypes.summary); },
        isDetailsResultView()           { return this.isResultsDetailsView && TestResults.isCurrentViewModeOfType(vmTypes.details); },

        isQuestionPresenterView()       { return this.isCurrentView(viewTypes.questionPresenter)},
        isSelfRatingView()              { return this.isCurrentView(viewTypes.selfRatingView)},
        isPerformanceSummaryView()      { return this.isCurrentView(viewTypes.performanceSummaryView)},
        isBlockIndexView()              { return this.isCurrentView(viewTypes.blockIntro)},
        isSubCategoryIndexView()        { return this.isCurrentView(viewTypes.subCategoryIntro)},
        isResultsDetailsView()          { return this.isCurrentView(viewTypes.resultsView)},

        currentView()                   { return TestState.getCurrentView() },
    },

    methods: {
        isRoute(name)           { return this.hasRouteName && this.routeName===name },
        isCurrentView(view)     { return TestState.isCurrentView(view) },
    }
};